import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "layout": "home",
  "title": "Education Progress",
  "lead": "Education lights every stage of the journey to a better life. To unlock the wider benefits of education, all children need access to education of good quality. Special efforts are needed to ensure that all children and young people – regardless of their family income, where they live, their gender, their ethnicity, whether they are disabled – can benefit equally from its transformative power. This requires sufficient resources, especially to reach those who need more support."
};
function _createMdxContent(props) {
  const _components = {
    a: "a",
    h1: "h1",
    p: "p",
    ..._provideComponents(),
    ...props.components
  }, {HighlightByTheme, IndexHero, LandingButton, LandingText, PageLink, RelatedContent, ThemeLinks} = _components;
  if (!HighlightByTheme) _missingMdxReference("HighlightByTheme", true);
  if (!IndexHero) _missingMdxReference("IndexHero", true);
  if (!LandingButton) _missingMdxReference("LandingButton", true);
  if (!LandingText) _missingMdxReference("LandingText", true);
  if (!PageLink) _missingMdxReference("PageLink", true);
  if (!RelatedContent) _missingMdxReference("RelatedContent", true);
  if (!ThemeLinks) _missingMdxReference("ThemeLinks", true);
  return _jsxs(_Fragment, {
    children: [_jsxs(IndexHero, {
      children: [_jsx(_components.h1, {
        id: "scope",
        children: "SCOPE"
      }), _jsxs(_components.p, {
        children: ["Bildung bringt Licht in jede Etappe auf dem Weg zu einem besseren Leben. Alle Kinder brauchen ", _jsx(HighlightByTheme, {
          theme: "access",
          children: "Zugang"
        }), " zu Bildung in guter ", _jsx(HighlightByTheme, {
          theme: "quality",
          children: "Qualität"
        }), ", um ihr ", _jsx(HighlightByTheme, {
          theme: "learning",
          children: "Lernpotenzial"
        }), " und die weiterreichenden Vorteile von Bildung voll auszuschöpfen. Besondere Bemühungen sind notwendig um zu gewährleisten, dass alle Kinder und Jugendlichen ", _jsx(HighlightByTheme, {
          theme: "equity",
          children: "chancengerecht"
        }), " von der transformativen Kraft von Bildung profitieren können. Dazu bedarf es ausreichender ", _jsx(HighlightByTheme, {
          theme: "finance",
          children: "Ressourcen"
        }), ", um besonders jene zu erreichen, die mehr Unterstützung benötigen."]
      })]
    }), "\n", _jsx(LandingText, {
      children: _jsxs(_components.p, {
        children: ["2015 beschloss die internationale Gemeinschaft 17 Ziele für nachhaltige Entwicklung (Sustainable Development Goals, SDGs), die bis 2030 erreicht werden sollen – darunter ", _jsx(_components.a, {
          href: "https://sustainabledevelopment.un.org/sdg4",
          children: "SDG 4"
        }), ", das sich ausschließlich dem Thema Bildung widmet. Seitdem wurde ein ", _jsx(PageLink, {
          name: "indicators",
          children: "sorgfältiger Rahmen"
        }), " zur Überwachung und Messung von Fortschritten auf dem Weg zur Erreichung der Unterziele von SDG 4 entwickelt und eingeführt. Auf dieser Website werden wichtige Fakten und Trends in der Bildung weltweit zu fünf Themenbereichen zusammengefasst:"]
      })
    }), "\n", _jsx(ThemeLinks, {}), "\n", _jsx(LandingText, {
      children: _jsxs(_components.p, {
        children: ["Sie ergänzt die Angaben und Informationen der Druckfassung des ", _jsx(_components.a, {
          href: "https://en.unesco.org/gem-report/allreports",
          children: "Weltbildungsberichts"
        }), ", dem Werkzeug der internationalen Gemeinschaft zur Überwachung und Messung von Fortschritten auf dem Weg zur Erreichung des Bildungsziels SDG 4."]
      })
    }), "\n", _jsx(LandingButton, {
      children: "Jetzt lesen"
    }), "\n", _jsx(RelatedContent, {})]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
